import { Jumbotron, Button, Tabs, Tab } from 'react-bootstrap';

const Parts = () => {
    return (
        <>
            <Jumbotron>
              <h1>ТОО "Синомост"</h1>
              <h2>Высшее качество | Оптимальная цена | Инновации</h2>
              <p>
                This is a simple hero unit, a simple jumbotron-style component for calling
                extra attention to featured content or information.
              </p>
              <p>
                <Button variant="primary">Узнать больше</Button>
              </p>
            </Jumbotron>

            <Tabs defaultActiveKey="profile" id="uncontrolled-tab-example">
              <Tab eventKey="home" title="Home">
                Elit ducimus nesciunt illo veritatis accusamus Unde distinctio veritatis officia at modi! Porro recusandae quidem quasi dignissimos facilis deserunt tenetur Doloremque quis a sit iste obcaecati labore. Saepe minima eligendi
              </Tab>
              <Tab eventKey="profile" title="Profile">
                Consectetur nostrum adipisci at officiis numquam! Ex veniam ipsum velit quas cumque quis saepe. Consequuntur eveniet perferendis tenetur quo voluptates voluptatem accusantium? Cumque molestiae sunt optio numquam labore Enim quos autem exercitationem ad ipsum! Consequuntur dolores molestiae fuga incidunt quis ullam assumenda Nostrum corporis maiores magni esse obcaecati Recusandae molestias.
              </Tab>
              <Tab eventKey="contact" title="Contact">
                Lorem non labore quia eos nulla Nostrum quas velit alias dicta iure? Dolor odio quisquam voluptatum obcaecati repellat facere rerum?
              </Tab>
            </Tabs>
        </>
    );
};

export default Parts;